import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const ViewYourMasterComponentStyle = styled('div')`
    &&.card {
        padding: 24px 16px;
    }

    @media print {
        background-color: var(--white) !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
    .header {
        color: var(--sand-700);
        ${typography.bodyXl}
        margin-bottom: 16px;
    }
    .titleDetailAtAGlance {
        color: var(--sand-600);
        ${typography.bodyMd}
        & + .titleDetailAtAGlance {
            margin-top: 6px;
        }
    }
`;

export default ViewYourMasterComponentStyle;
